import {
    GET_SALESPERSON_HIERARCHY_REQUEST, GET_SALESPERSON_HIERARCHY_SUCCESS, GET_SALESPERSON_HIERARCHY_ERROR, GET_ALL_SALEPERSON_HIERARCHY_ERROR, GET_ALL_SALEPERSON_HIERARCHY_REQUEST, GET_ALL_SALEPERSON_HIERARCHY_SUCCESS,
    CREATE_SALESPERSON_HIERARCHY_REQUEST,
    CREATE_SALESPERSON_HIERARCHY_SUCCESS,
    CREATE_SALESPERSON_HIERARCHY_ERROR,
    DELETE_SALESPERSON_HIERARCHY_REQUEST,
    DELETE_SALESPERSON_HIERARCHY_SUCCESS,
    DELETE_SALESPERSON_HIERARCHY_ERROR,
    UPDATE_SALESPERSON_HIERARCHY_REQUEST,
    UPDATE_SALESPERSON_HIERARCHY_SUCCESS,
    UPDATE_SALESPERSON_HIERARCHY_ERROR,
    GET_SALESPERSON_REQUEST,
    GET_SALESPERSON_SUCCESS,
    GET_SALESPERSON_ERROR


} from "./types.js"
import axios from "axios";
import { BASEURL } from "../../constant/config.js"


///GET CUSTOMER TYPE
export const loadSalesPersons = (token, id) => dispatch => {
    dispatch({ type: GET_SALESPERSON_REQUEST });
    return axios({
        method: "GET",
        url: `${BASEURL}getOne/salesPerson/${id}`,
        headers: {
            Accept: "application/json",
            'Authorization': 'Bearer ' + token
        }
    })
        .then(response => {

            return dispatch({ type: GET_SALESPERSON_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            if (error.response.data.data === "No Record Found !") {
                return dispatch({
                    type: GET_SALESPERSON_ERROR,
                    payload: [],
                });
            }
            return dispatch({
                type: GET_SALESPERSON_ERROR,
                payload: error.response,
            });
        })
};


export const getAllSalepersonhierarchy = (token, id) => dispatch => {
    dispatch({ type: GET_ALL_SALEPERSON_HIERARCHY_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/salesPersonHierarchy`,
        headers: {
            Accept: "application/json",
            'Authorization': 'Bearer ' + token
        }
    })
        .then(response => {
            return dispatch({ type: GET_ALL_SALEPERSON_HIERARCHY_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: GET_ALL_SALEPERSON_HIERARCHY_ERROR,
                payload: error.response,
            });
        })
}


export const createSalepersonhierarchy = (token, data) => dispatch => {
    dispatch({ type: CREATE_SALESPERSON_HIERARCHY_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}create/salesPersonHierarchy`,
        headers: {
            Accept: "application/json",
            'Authorization': 'Bearer ' + token
        },
        data: data
    })
        .then(response => {
            return dispatch({ type: CREATE_SALESPERSON_HIERARCHY_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: CREATE_SALESPERSON_HIERARCHY_ERROR,
                payload: error.response,
            });
        })
}


export const updateSalepersonhierarchy = (token, data, id) => dispatch => {
    dispatch({ type: UPDATE_SALESPERSON_HIERARCHY_REQUEST });
    return axios({
        method: "PUT",
        url: `${BASEURL}update/salesPersonHierarchy/${id}`,
        headers: {
            Accept: "application/json",
            'Authorization': 'Bearer ' + token
        },
        data: data
    })
        .then(response => {
            return dispatch({ type: UPDATE_SALESPERSON_HIERARCHY_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: UPDATE_SALESPERSON_HIERARCHY_ERROR,
                payload: error.response,
            });
        })
}

export const deleteSalepersonhierarchy = (token, id) => dispatch => {
    dispatch({ type: DELETE_SALESPERSON_HIERARCHY_REQUEST });
    return axios({
        method: "DELETE",
        url: `${BASEURL}delete/salesPersonHierarchy/${id}`,
        headers: {
            Accept: "application/json",
            'Authorization': 'Bearer ' + token
        },
        // data: data
    })
        .then(response => {
            return dispatch({ type: DELETE_SALESPERSON_HIERARCHY_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: DELETE_SALESPERSON_HIERARCHY_ERROR,
                payload: error.response,
            });
        })
}



